export const GET_CART_REQUEST="GET_CART_REQUEST";
export const GET_CART_SUCCESS="GET_CART_SUCCESS";
export const GET_CART_ERROR="GET_CART_ERROR";
// ================================================

export const DELETE_CART_REQUEST="DELETE_CART_REQUEST";
export const DELETE_CART_SUCCESS="DELETE_CART_SUCCESS";
export const DELETE_CART_ERROR="DELETE_CART_ERROR";
